export function aiChatErrorMessage(errorCode?: string): string {
  if (errorCode === 'rate_limited' || errorCode === 'branch_daily_limit') {
    return 'Llegaste al límite de consultas por hoy. Probá de nuevo más tarde.';
  }
  if (errorCode === 'groq_not_configured') return 'El asistente no está disponible todavía. Contactá a soporte.';
  if (errorCode === 'invalid_payload') return 'No pude enviar esa consulta. Probá escribirla de nuevo.';
  return 'No pude responder en este momento. Probá de nuevo más tarde.';
}
